<!-- 店铺资金流水弹窗 -->
<template>
  <el-dialog
    title="店铺资金流水"
    :visible="visible"
    width="80%"
    :before-close="onClose"
    v-loading="loading"
    append-to-body
  >
    <div class="title">当前店铺：{{ shop.name || '-' }}</div>
    <VQuery
      :params="queryParam"
      :modules="queryModels"
      :operation="queryOperation"
      @search="search"
      @reset="search"
    ></VQuery>
    <div class="tab margin-top-sm"></div>
    <el-menu
      :default-active="activeMenu"
      class="el-menu-demo"
      mode="horizontal"
      @select="activeMenuSelect"
    >
      <el-menu-item index="ALL">全部</el-menu-item>
      <el-menu-item index="t1">余额</el-menu-item>
      <el-menu-item index="t2">提现冻结金额</el-menu-item>
      <el-menu-item index="t3">待结算金额</el-menu-item>
      <el-menu-item index="t4">总收益</el-menu-item>
      <el-menu-item index="t5">已提现金额</el-menu-item>
    </el-menu>
    <VTable
      :tableHander="tableHander"
      :total="tableTotal"
      :data="tableData"
      @sizeChange="sizeChange"
      @pageChange="pageChange"
      @selectChange="selectChange"
    ></VTable>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  QueryShopWealthRecordList,
  QueryAllShopNameList,
  ExportShopWealthRecordList
} from '@/api'
import constan from '@/utils/constant'
import { DateFormat } from '@/utils/date/DateUtil'
import { ShopWealthRecordTypeFormat,ShopWealthWayTypeFormat,PriceFormat } from '@/utils/tyepconvert'

import {
  VQuery,
  VTable,
  QueryModel,
  TableHander,
  TableOperation
} from '@/components/table'
export default {
  name: 'LLpayMechantActity',
  components: { VQuery, VTable },
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      shop: {},
      queryParam: {
        startRow: 1,
        limit: 10
      },
      tableTotal: 0,
      tableData: [],
      tableCurrntPage: 1,
      activeMenu: "ALL",
      selectData:[],
      // 查询条件
      queryModels:[
        { title: '资金类型', param: 'type', type: 'select',selectData: constan.ShopWealthRecordType },
        { title: '变更途径', param: 'wayType', type: 'select',selectData: constan.ShopWealthWayType },
        { title: '关联号', param: 'recordNo' },
        { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
      ],
      // 全局操作
      queryOperation:[{ title: '批量导出', type: 'primary', click: this.exportHandle}],
      // 数据表头
      tableHander:[
        { title: '选择',  type: 'selection' },
        { title: '编号', param: 'id' ,width: 80},
        { title: '店铺ID', param: 'shopId',width: 120 },
        { title: '店铺名称', param: 'shopName',width: 200,overflow: true },
        { title: '资金类型', param: 'type' , formatter: ShopWealthRecordTypeFormat},
        { title: '变动金额', param: 'qty', formatter: PriceFormat },
        { title: '变更途径', param: 'wayType' , formatter: ShopWealthWayTypeFormat},
        { title: '关联号', param: 'recordNo' },
        { title: '创建时间', param: 'createTime', formatter: DateFormat },
      ]
    }
  },
  methods: {
    // 表单勾选
    selectChange(selection) {
      this.selectData = selection
    },
    // 。选择菜单
    activeMenuSelect(e){
      if(this.activeMenu == e){
        return
      }
      this.activeMenu = e
      this.search()
    },
    onClose() {
      this.visible = false
      this.queryParam = {
        startRow: 1,
        limit: 10
      }
      this.tableTotal = 0
      this.tableData = []
      this.activeMenu = "ALL"
      this.$emit('close')
    },
    open(shop) {
      this.visible = true
      this.shop = shop
      this.queryParam.shopId = shop.id
      this.loadData()
    },
    exportHandle(){
      // 导出
      // if(this.selectData.length <= 0){
      //   return
      // }

      const loading = this.$loading({
            lock: true,
            text: '正在导出数据',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

        const param = this.getRequestParam()
        param.limit = ""
        param.startRow = ""

        const ids = this.selectData.map(e=>e.id)
        param.ids = ids

        ExportShopWealthRecordList(param,"导出店铺流水.xlsx").then(res=>{
          loading.close()
        }).catch(()=>{
          loading.close()
        })

    },
    async loadData() {
      const param = this.getRequestParam()
      const result = await QueryShopWealthRecordList(param)
      this.tableTotal = result.total
      this.tableData = result.list
    },
    getRequestParam(){
      const param = { ...this.queryParam }
      param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)

      if(this.activeMenu == 't1'){
        param.type = 1
      } else if(this.activeMenu == 't2'){
        param.type = 2
      } else if(this.activeMenu == 't3'){
        param.type = 3
      } else if(this.activeMenu == 't4'){
        param.type = 4
      } else if(this.activeMenu == 't5'){
        param.type = 5
      } 
      if (param.createTimeDaterange) {
        param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
      }
      return param
    },
    search() {
      console.log(this.queryParam)
      this.tableCurrntPage = 1
      this.loadData()
    },
    pageChange(index) {
      this.tableCurrntPage = index
      this.loadData()
    },
    sizeChange(index) {
      this.tableCurrntPage = 1
      this.queryParam.limit = index
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.meta-top {
  color: #909399;
  font-size: 12px;
  margin-bottom: 8px;
}

.meta-top > span + span {
  margin-left: 20px;
}

.block {
  border: 1px solid var(--color-border, #ebeef5);
  border-radius: 8px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 0;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
::v-deep .el-card .el-card__header {
  padding: 14px 15px 7px;
  min-height: 40px;
  background: #fafafa;
}
</style>
